import { SuperHeroSecondaryCard } from 'ui/components';

export const SuperHeroSecondaryCardFeature: React.FC<Umbraco.SuperHeroSecondaryCard> = ({ content }) => (
	<SuperHeroSecondaryCard {...content?.properties} />
);
